import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NewsState, newsFeatureKey } from './news.state';

export const selectNewStateRoot =
  createFeatureSelector<NewsState>(newsFeatureKey);

export const selectNews = createSelector(
  selectNewStateRoot,
  (state) => state.news
);

export const selectNewsTypes = createSelector(
  selectNewStateRoot,
  (state) => state.newsTypes
);

export const selectLoading = createSelector(
  selectNewStateRoot,
  (state) => state.loading
);
